import React, { useState } from "react";
import styled from "styled-components";
import { useContext } from "react";
import { PostsContext } from "../../context/posts";
const CheckBox = styled.input`
    position: absolute;
    appearance: none;
    border: 1px solid black;
    width: 16px;
    height: 16px;
    border-radius: 100px;
    cursor: pointer;

    &:checked {
        background-color: #f5ad2c;
    }
`;

const CardWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
    width: 96%;
    margin-bottom: 0.9rem;
    border-bottom: 1px solid #dddddd;
`;

const CardText = styled.div`
    p {
        width: 590px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
`;

const Image = styled.img`
    margin-left: 1.5rem;
    width: 40px;
    height: 40px;
    object-fit: contain;
    
`;



const CardProductFacebook = ({ name, image, id }) => {
    const {ids,setIds} = useContext(PostsContext)

    const handleSelectIdProduct = (selectedId) => {
        setIds((prevIds) =>
            prevIds.includes(selectedId) 
                ? prevIds.filter((item) => item !== selectedId) 
                : [...prevIds, selectedId]
        );
    };

    return (
        <CardWrapper onClick={() => handleSelectIdProduct(id)}>
            <CheckBox 
                type="checkbox"
                checked={ids.includes(id)}
                readOnly // Evita erro de controle do React
            />
            <Image src={image} alt={name} />
            <CardText>
                <p>{name}</p>
            </CardText>
        </CardWrapper>
    );
};

export default CardProductFacebook;
